import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import useDocumentScrollThrottled from './UseDocumentScrollThrottled';

const Header = ({ context }) => {
    
    const ctxMenu 	= () => context.menu;
	const menu 		= ctxMenu();
	
	let activeIndex = 0;
		
    if (context.menu) {
	    
		const ctxMenu 	= () => context.menu;
		const menu 		= ctxMenu();
						
		if (menu.json === null) {
			context.getMenu(window.location.origin + '/wp-json/penfold/v1/menu');
		}
		
		function handleMenuToggle(evt) {
		  	evt.preventDefault();
		  	context.toggleMenu();
	  	}
	  	
	  	function handleMouseOver(evt) {
	  		let color = '#2C2C2C';
	  		let bgColor = evt.currentTarget.getAttribute('data-color');
	  		if (evt.currentTarget.getAttribute('data-text-color') === 'light') {
		  		color = '#FFF';
	  		}
	  		context.changeMenuColour(color, bgColor, true);
	  	}
	  	
	  	function handleMouseOut(evt) {
	  		let color = '#2C2C2C';
	  		let bgColor = '#FFF';
	  		context.changeMenuColour(color, bgColor, false);
	  	}
	  		  	
	  	if (menu.json !== null) {  
		  	
		  	let location 	= menu.location;
		  	let links 		= [];
		  	let mobLinks 	= [];
		  	let activeLinks = [];
		  	
		  	let bgColor 	= '#FFF';
		  	let color 		= '#2C2C2C';
		  	
		  	if (location === '/' || location === '') {
			  	mobLinks.push(<li><Link className="state-active" to={{ pathname: '/' + menu.json.menu_home}} dangerouslySetInnerHTML={{__html:'Home'}}></Link></li>);
			  	bgColor = menu.json.menu_home_clr;
			  	color 	= menu.json.menu_home_clr_text;
		  	} else {
			  	mobLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_home}} dangerouslySetInnerHTML={{__html:'Home'}} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} data-text-color={menu.json.menu_home_clr_text} data-color={menu.json.menu_home_clr}></Link></li>);
			  	
		  	}
		  	
		  	
		  	if (location.indexOf(menu.json.menu_about) === -1) {
			  	links.push(<li><Link to={{ pathname: '/' + menu.json.menu_about}} dangerouslySetInnerHTML={{__html:'About'}}></Link></li>);
			  	mobLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_about}} dangerouslySetInnerHTML={{__html:'About'}} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} data-text-color={menu.json.menu_about_clr_text} data-color={menu.json.menu_about_clr}></Link></li>);
		  	} else {
			  	activeLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_about}} dangerouslySetInnerHTML={{__html:'About'}}></Link></li>);
			  	mobLinks.push(<li><Link className="state-active" to={{ pathname: '/' + menu.json.menu_about}} dangerouslySetInnerHTML={{__html:'About'}}></Link></li>);
			  	bgColor = menu.json.menu_about_clr;
			  	color 	= menu.json.menu_about_clr_text;
		  	}
		  	
		  	if (location.indexOf(menu.json.menu_about) === -1 && location.indexOf(menu.json.menu_contact) === -1 && location.indexOf(menu.json.menu_collaborators) === -1 && location !== '/' && location !== '') {
			  	activeLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_projects}} dangerouslySetInnerHTML={{__html:'Projects'}}></Link></li>);
			  	mobLinks.push(<li><Link className="state-active" to={{ pathname: '/' + menu.json.menu_projects}} dangerouslySetInnerHTML={{__html:'Projects'}}></Link></li>);
			  	bgColor = menu.json.menu_projects_clr;
			  	color 	= menu.json.menu_projects_clr_text;
		  	} else {
			  	links.push(<li><Link to={{ pathname: '/' + menu.json.menu_projects}} dangerouslySetInnerHTML={{__html:'Projects'}}></Link></li>);
			  	mobLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_projects}} dangerouslySetInnerHTML={{__html:'Projects'}} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} data-text-color={menu.json.menu_projects_clr_text} data-color={menu.json.menu_projects_clr}></Link></li>);
			  	
		  	}
		  	
		  	if (location.indexOf(menu.json.menu_collaborators) === -1) {
			  	links.push(<li><Link to={{ pathname: '/' + menu.json.menu_collaborators}} dangerouslySetInnerHTML={{__html:'Collaborators'}}></Link></li>);
			  	mobLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_collaborators}} dangerouslySetInnerHTML={{__html:'Collaborators'}} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} data-text-color={menu.json.menu_contact_clr_text} data-color={menu.json.menu_contact_clr}></Link></li>);
		  	} else {
			  	activeLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_collaborators}} dangerouslySetInnerHTML={{__html:'Collaborators'}}></Link></li>);
			  	mobLinks.push(<li><Link className="state-active" to={{ pathname: '/' + menu.json.menu_collaborators}} dangerouslySetInnerHTML={{__html:'Collaborators'}}></Link></li>);
			  	bgColor = menu.json.menu_collaborators_clr;
			  	color 	= menu.json.menu_collaborators_clr_text;
		  	}
		  	
		  	if (location.indexOf(menu.json.menu_contact) === -1) {
			  	links.push(<li><Link to={{ pathname: '/' + menu.json.menu_contact}} dangerouslySetInnerHTML={{__html:'Contact'}}></Link></li>);
			  	mobLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_contact}} dangerouslySetInnerHTML={{__html:'Contact'}} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} data-text-color={menu.json.menu_contact_clr_text} data-color={menu.json.menu_contact_clr}></Link></li>);
		  	} else {
			  	activeLinks.push(<li><Link to={{ pathname: '/' + menu.json.menu_contact}} dangerouslySetInnerHTML={{__html:'Contact'}}></Link></li>);
			  	mobLinks.push(<li><Link className="state-active" to={{ pathname: '/' + menu.json.menu_contact}} dangerouslySetInnerHTML={{__html:'Contact'}}></Link></li>);
			  	bgColor = menu.json.menu_contact_clr;
			  	color 	= menu.json.menu_contact_clr_text;
		  	}
		  	
		  	if (bgColor !== menu.bgColor && menu.hover === false) {
			  	context.changeMenuColour(color, bgColor, false);
		  	}
		  	
		  	let buttonClass = 'c-header__menu-button';
		  	let headerClass = 'c-header state-menu-closed';
		  	let navClass 	= 'c-header__nav state-menu-closed';
		  	if (menu.open === true) {
			  	buttonClass = 'c-header__menu-button state-menu-open';
			  	headerClass = 'c-header state-menu-open';
			  	navClass 	= 'c-header__nav state-menu-open';
		  	}
		  	
		  	let headerColor = '#2c2c2c';
		  	if (menu.hover === true) {
			  	headerColor = color;
		  	}
		  	
		  	
		  	if (color == 'light') {
			  	color = '#FFF';
		  	} else if (color == 'dark') {
			  	color = '#2C2C2C';
		  	}
		  	if (menu.hover === true) {
			  	color 	= menu.color;
			  	bgColor = menu.bgColor;
		  	}

		  	document.documentElement.style.setProperty('--menu-fg', color);
		  	document.documentElement.style.setProperty('--menu-bg', bgColor);
		  	
			return (
				<>
			    	<header className={headerClass}>
			    		<div className="l-content">
			    			<div className="l-grid">
			    				<div className="l-grid__col l-grid__col--m-3-12">
									<h1 className="c-header__logo">
										<Link to={{ pathname: '/' }} className="c-header__logo__inner">Penfold</Link>
									</h1>
									<a href="#"  onClick={handleMenuToggle} className={buttonClass} dangerouslySetInnerHTML={{__html:'<svg class="c-arrow" x="0px" y="0px" viewBox="0 0 46 36"><path style="fill:#2C2C2C" d="M22.22,0.05l15.78,15.89H0.46v3.93h37.71L22.22,35.95h5.44L45.54,18L27.65,0.05H22.22 z"/></svg>'}}></a>
								</div>
								<div className="l-grid__col l-grid__col--m-3-12 c-header__desktop-el">
									<ul className="scope-desktop-menu">
										{activeLinks}
									</ul>
								</div>
								<div className="l-grid__col l-grid__col--m-6-12 c-header__desktop-el">
									<ul className="scope-desktop-menu scope-desktop-menu--right">
										{links}
									</ul>
								</div>
							</div>
						</div>
					</header>
					
					<nav className={navClass}>
						<ul className="c-header__nav__list">
							{mobLinks}
						</ul>
					</nav>
					
				</>
			)
		
		} else {
			
			return null;
			
		}
		
	} else {
		
		return null;
		
	}
		
}
export default WithConsumer(Header);